// extracted by mini-css-extract-plugin
export default {"overlay":"Player_overlay__4dLXP","player":"Player_player__HGfQc"};